import type { DepartureTimeRange } from "@app/modules/results/state/filters";

export const getDepartureTimeRange = (
  departure_time: string
): DepartureTimeRange[] => {
  const time_ranges: DepartureTimeRange[] = [];

  if (departure_time < "06:00") {
    time_ranges.push("nighttime");
  }
  if (departure_time >= "06:00" && departure_time <= "11:00") {
    time_ranges.push("early");
  }
  if (departure_time >= "11:00" && departure_time <= "17:00") {
    time_ranges.push("midday");
  }
  if (departure_time >= "17:00") {
    time_ranges.push("late");
  }

  return time_ranges;
};
